import { createFileRoute, redirect } from '@tanstack/react-router';
import { ensurePermissions } from '@/hooks/usePermissions';

export const Route = createFileRoute('/(client)/audits')({
  // Layout route for every audits screen, so the read permission is asked
  // once here rather than on each child route.
  beforeLoad: async ({ location }) => {
    const perms = await ensurePermissions();
    if (!perms.audit.canRead) {
      throw redirect({ to: '/dashboard' });
    }

    if (location.pathname === '/audits' || location.pathname === '/audits/') {
      throw redirect({ to: '/audits/network-audits/active' });
    }
  },
});
